export default "__VITE_ASSET__DDXtg001__"